import { tw } from "@careinfo/tailwind";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import APIS from "../../constant/EndPoint";
import usePatchHook from "../../customHooks/usePatchHook";
import Button from "../Reusable/Button";
import TextField from "../Reusable/TextInput";
import { EmailSettingsValidationForm } from "../../utils/validationSchemas";
import usePostHook from "../../customHooks/usePostHook";
import NACell from "../Reusable/DataTable/NACell";
import DataTable from "../Reusable/DataTable";
import { AccessControl } from "@careinfo/permission-required";
import SwitchButton from "../Reusable/SwitchButton";
import { useParams } from "react-router";
import { useState } from "react";
import Modal from "../Reusable/Modal";
import CreateEmail from "../../pages/User/CreateEmail";
import { TrashIcon } from "@heroicons/react/24/outline";
import useDeleteHook from "../../customHooks/useDeleteHook";

const EmailSettings = (props: any) => {
  const { user, email } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [openDeletePopup, setOpenDeletePopup] = useState(false);
  const [selectedAccount, setselectedAccount] = useState(null);
  const { setError } = useForm({});

  const { id } = useParams();
  const { mutateAsync: deleteAccount, isLoading } = useDeleteHook({
    queryKey: ["users-accounts"],
  });

  const { mutateAsync, isLoading: isPostLoading } = usePatchHook({
    queryKey: ["users-accounts"],
    navigateURL: "",
  });

  const handleToggle = async (id: string, isActive: boolean) => {
    const url = `${APIS.ACCOUNTS}${id}/`;
    const formData = { is_active: isActive };
    try {
      await mutateAsync({ url, formData, setError: () => {} });
    } catch (err) {
      console.log(err);
    }
  };
  const handleDelete = async (
    id: any,
    setOpenDeletePopup: any,
    setError: any
  ) => {
    const url = `${APIS.ACCOUNTS}${id}/`;
    let formData = {};
    try {
      const res = await deleteAccount({ url, formData, setError });
      if (res?.status === 204) {
        setOpenDeletePopup(false);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const defaultColumns: any = [
    {
      header: "Full Name",
      accessorKey: "full_name",
      cell: NACell,
    },
    {
      header: "Email",
      accessorKey: "email",
      cell: NACell,
    },
    {
      header: "Username",
      accessorKey: "username",
      cell: NACell,
    },
    {
      header: "Default",
      accessorKey: "is_active",
      cell: ({ row, getValue }) => (
        <AccessControl
          children={
            <SwitchButton
              id={row?.original?.id}
              value={getValue()}
              disabled={isPostLoading}
              onChange={(newValue: boolean) =>
                handleToggle(row?.original?.id, newValue)
              }
            />
          }
          allowedPermissions={["can_update_user"]}
          renderNoAccess={
            <SwitchButton
              id={row?.original?.account_id}
              value={getValue()}
              disabled={true}
              onChange={() => {}}
            />
          }
        />
      ),
    },
    {
      header: "Action",
      accessorKey: "id",
      cell: ({ row, getValue }: any) => (
        <>
          <div className={tw`grid grid-cols-2 items-center `}>
            <button
              type="button"
              disabled={isLoading || false}
              onClick={() => {
                setselectedAccount(row?.original.id);
                setOpenDeletePopup(!openDeletePopup);
              }}
              className="focus:outline-none"
            >
              <TrashIcon color={"var(--primary)"} height={20} width={20} />
            </button>
          </div>
        </>
      ),
    },
  ];

  return (
    <>
      <DataTable
        url={APIS.ACCOUNTS}
        queryKey={"users-accounts"}
        params={{
          user: id,
        }}
        columns={defaultColumns}
        // addNewPagePath={"/create"}
        tableName={"user-account"}
        actionMenu={
          <>
            <div className={tw`flex items-center`}>
              <button
                className={tw`border-2 px-2 py-1 rounded-lg outline:focus-none`}
                type="button"
                onClick={() => setIsOpen(!isOpen)}
              >
                Create New Account
              </button>
            </div>
          </>
        }
      />
      <Modal title={"Create New Account"} isOpen={isOpen} setIsOpen={setIsOpen}>
        <CreateEmail isOpen={isOpen} setIsOpen={setIsOpen} />
      </Modal>
      <Modal isOpen={openDeletePopup} setIsOpen={setOpenDeletePopup} title={""}>
        <div className={tw`flex flex-col justify-center items-center  h-fit`}>
          <p className={tw`text-lg font-semibold mb-4`}>
            Are you sure you want to delete ?
          </p>
          <div className={tw`mt-6 flex gap-x-6 items-center`}>
            <div className={tw`w-24`}>
              <Button
                label={"Yes"}
                isLoading={isLoading}
                onClick={() =>
                  handleDelete(selectedAccount, setOpenDeletePopup, setError)
                }
              />
            </div>
            <div>
              <button
                type="button"
                className={tw`w-full px-[24px] py-2 rounded  focus:outline-none bg-[#EEF5F4]`}
                onClick={() => setOpenDeletePopup(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default EmailSettings;
